<template>
    <!-- left
        dark
        icons-and-text    mr-5 dark color="#ffbc00"-->
  <div>
    
      <v-tabs
        v-model="tabDinamic"
        @change="hearChange"
        class="rounded-lg"
        dense
        dark
        background-color="primary"
        slider-color="#ffbc00"
        active-class="tab-active"       
      >
          <v-tab v-for="item in itemsTabs" :key="item.id" :to="item.route" :class="item.class">
            <!-- <v-icon>{{ item.icono }}</v-icon> -->
          {{ item.titulo }}
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="tabDinamic" @change="update($event)" touchless>
        <v-tab-item
          v-for="item in itemsTabs"
          :key="item.titulo"
          :value="item.route"
        >
        <!-- v-if="item.route === tabDinamic" -->
          <!-- <slot :name="item.contenido"></slot> -->
   
             <router-view v-if="item.route === tabDinamic"/>
   
        </v-tab-item>
      </v-tabs-items>
  </div>
</template>
<script>
export default {
  name: "ComTabSimulador",
  props: {
    tab: {
      type: String,
      default: null,
    },
    itemsTabs: {
      type: Array,
      required: true,
    },
  },
  components: {},
  data: () => ({
    tabDinamic: null,
  }),
  methods: {
    update(e){
      this.$router.push(e);
    },
    hearChange(tab) {
      // console.log('desde el Metodo: ' + tab);
      this.$emit("change-tab", tab );
    },
  },
  watch: {
    tab: function (e) {
      // console.log('desde el Watch: ' + e);
      this.tabDinamic = e;
    },
  },
};
</script>

<style></style>
